import type { MediaCard as MediaCardModel } from "@/types/site";

interface MediaCardProps {
  card: MediaCardModel;
  compact?: boolean;
}

export function MediaCard({ card, compact = false }: MediaCardProps) {
  return (
    <article className="overflow-hidden rounded-[1.5rem] border border-outline/10 bg-surface-high transition hover:border-primary/20">
      <div className={compact ? "aspect-[4/3]" : "aspect-video"}>
        <img src={card.image} alt="" className="h-full w-full object-cover" />
      </div>
      <div className="space-y-3 p-6">
        <p className="eyebrow !text-[0.62rem]">{card.category}</p>
        <h3 className={compact ? "font-display text-xl text-text" : "font-display text-2xl text-text"}>{card.title}</h3>
        <p className="text-sm leading-7 text-muted">{card.description}</p>
        {card.meta ? <p className="font-label text-xs uppercase tracking-[0.2em] text-muted">{card.meta}</p> : null}
      </div>
    </article>
  );
}
